const beardData = [
    {
        id: 1,
        text: "DYE YOUR HAIR AND BEARD 1",
        price: "$7",
    },
    {
        id: 2,
        text: "DYE YOUR HAIR AND BEARD 2",
        price: "$10",
    },
    {
        id: 3,
        text: "DYE YOUR HAIR AND BEARD 3",
        price: "$15",
    },
    {
        id: 4,
        text: "DYE YOUR HAIR AND BEARD 4",
        price: "$15"
    },
    {
        id: 5,
        text: "DYE YOUR HAIR AND BEARD 5",
        price: "$20"
    },
    {
        id: 6,
        text: "DYE YOUR HAIR AND BEARD 6",
        price: "$25"
    },

];

export default beardData;